import React from 'react';
import { useData } from '../context/DataContext';
import SEO from '../components/SEO';

const Exhibitions = () => {
  const { exhibitions } = useData();
  return (
    <div className="animate-in fade-in slide-in-from-bottom-4 duration-700 pb-20">
      <SEO 
        title="Exhibitions Archive" 
        description="Archive of exhibitions, shows, and performances by Leon Krykhtin."
        url="/exhibitions"
      />
      <h2 className="text-3xl font-bold tracking-tighter uppercase mb-12">Exhibition Archive</h2>
      
      <div className="space-y-12">
        {exhibitions.map((exhibition, index) => (
          <div key={index} className="flex flex-col md:flex-row md:items-baseline border-b border-neutral-200 pb-8 last:border-0 group">
            <span className="text-sm font-mono text-neutral-400 w-24 mb-2 md:mb-0 shrink-0">{exhibition.year}</span>
            <div className="flex-1">
              <h3 className="text-xl font-bold uppercase tracking-tight mb-1 group-hover:text-neutral-600 transition-colors">
                {exhibition.title}
              </h3>
              <div className="flex flex-col sm:flex-row sm:items-center text-neutral-500 text-sm mb-2">
                <span>{exhibition.location}</span>
                <span className="hidden sm:inline mx-2">•</span>
                <span className="italic">{exhibition.type}</span>
              </div>
              
              {exhibition.link && (
                <a 
                    href={exhibition.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-xs uppercase tracking-widest text-neutral-400 hover:text-black transition-colors border-b border-transparent hover:border-black inline-block mt-1"
                >
                    View Details
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Exhibitions;
